import {
  GET_GASPROJECTS,
  GET_GASPROJECTS_FAIL,
  GET_GASPROJECTS_SUCCESS,
  RESET_GASPROJECT_FLAG,
  UPSERT_GASPROJECT,
  UPSERT_GASPROJECT_FAIL,
  UPSERT_GASPROJECT_SUCCESS,
  ADD_FILE_GASPROJECT,
  ADD_FILE_GASPROJECT_FAIL,
  ADD_FILE_GASPROJECT_SUCCESS,
  GET_GASPROJECTS_ENG,
  GET_GASPROJECTS_ENG_SUCCESS,
  GET_GASPROJECTS_ENG_FAIL,
  GET_PACKAGEINSTALLER,
  GET_PACKAGEINSTALLER_SUCCESS,
  GET_PACKAGEINSTALLER_FAIL,
  UPDATE_PROCESS_EXPERT_STAGE,
  UPDATE_PROCESS_MAP_STAGE,
  UPDATE_PROCESS_STAGE_SUCCESS,
  UPDATE_PROCESS_STAGE_FAIL,
  GET_GASPROJECT_FILES,
  GET_GASPROJECT_FILES_SUCCESS,
  GET_GASPROJECT_FILES_FAIL,
  ADD_FILE_GASPROJECT_SINGLE,
  SEND_GASPROJECT_TOGAS,
  SEND_GASPROJECT_TOGAS_SUCCESS,
  SEND_GASPROJECT_TOGAS_FAIL,
  SUBMIT_GASPROJECT_ADMIN,
  SUBMIT_GASPROJECT_ADMIN_SUCCESS,
  SUBMIT_GASPROJECT_ADMIN_FAIL,
  ADD_PACKAGE_INSTALLER,
  ADD_PACKAGE_INSTALLER_SUCCESS,
  ADD_PACKAGE_INSTALLER_FAIL,
  SUBMIT_PACKAGE,
  SUBMIT_PACKAGE_SUCCESS,
  SUBMIT_PACKAGE_FAIL,
  UPDATE_GASPROJECT_DETAILS,
  UPDATE_GASPROJECT_DETAILS_SUCCESS,
  UPDATE_GASPROJECT_DETAILS_FAIL,
  DELETE_GASPROJECT,
  DELETE_GASPROJECT_SUCCESS,
  DELETE_GASPROJECT_FAIL,
  UPDATE_GASPROJECT,
  UPDATE_GASPROJECT_SUCCESS,
  UPDATE_GASPROJECT_FAIL,
  UPDATE_GASPROJECT_ENG,
  UPDATE_PROCESS_DEFECT_STAGE,
  GET_GASPROJECT_REPORT,
  GET_GASPROJECT_REPORT_SUCCESS,
  GET_GASPROJECT_REPORT_FAIL,
  GET_GASPROJECT_FREE,
  GET_GASPROJECT_FREE_SUCCESS,
  GET_GASPROJECT_FREE_FAIL,
  GET_GASPROJECTS_FILTER,
  GET_GASPROJECTS_FILTER_FAIL,
  GET_GASPROJECTS_FILTER_SUCCESS,
  GET_GASPROJECTS_FULL_FILTER,
  GET_GASPROJECTS_FULL_FILTER_SUCCESS,
  GET_GASPROJECTS_FULL_FILTER_FAIL,
  UPDATE_PROCESS_EXPERT_STAGE_NEW,
  UPDATE_PROCESS_MAP_STAGE_NEW,
  UPDATE_PROCESS_DEFECT_STAGE_NEW,
  UPDATE_PROCESS_STAGE_NEW_SUCCESS,
  UPDATE_PROCESS_STAGE_NEW_FAIL,
  UPDATE_GASPROJECT_DETAILS_NEW,
  UPDATE_GASPROJECT_DETAILS_NEW_SUCCESS,
  UPDATE_GASPROJECT_DETAILS_NEW_FAIL,
  UPDATE_GASPROJECT_ENG_NEW,
  RESET_PACKAGE,
  RESET_PACKAGE_SUCCESS,
  RESET_PACKAGE_FAIL,
  RESOLVED_DEFECT,
  RESOLVED_DEFECT_SUCCESS,
  RESOLVED_DEFECT_FAIL,
  STOP_GASPROJECT,
  STOP_GASPROJECT_SUCCESS,
  STOP_GASPROJECT_FAIL,
  PREPARE_MAPSTAGE,
  PREPARE_MAPSTAGE_SUCCESS,
  PREPARE_MAPSTAGE_FAIL,
  SUBMIT_DESIGN_STAGE,
  SUBMIT_DESIGN_STAGE_SUCCESS,
  SUBMIT_DESIGN_STAGE_FAIL,
  PREPARE_FIRSTSUPERVISION_STAGE,
  PREPARE_FIRSTSUPERVISION_STAGE_SUCCESS,
  PREPARE_FIRSTSUPERVISION_STAGE_FAIL,
  UPDATE_GASPROJECT_CHECKLIST,
  UPDATE_GASPROJECT_CHECKLIST_SUCCESS,
  UPDATE_GASPROJECT_CHECKLIST_FAIL,
  SUBMIT_FIRSTSUPERVISION_STAGE,
  SUBMIT_FIRSTSUPERVISION_STAGE_SUCCESS,
  SUBMIT_FIRSTSUPERVISION_STAGE_FAIL,
  DELETE_GASPROJECT_FILE,
  DELETE_GASPROJECT_FILE_SUCCESS,
  DELETE_GASPROJECT_FILE_FAIL,
  PREPARE_DESIGNS_STAGE,
  PREPARE_DESIGNS_STAGE_SUCCESS,
  PREPARE_DESIGNS_STAGE_FAIL,
  PAY_BY_EXECUTOR_WALLET,
  PAY_BY_EXECUTOR_WALLET_SUCCESS,
  PAY_BY_EXECUTOR_WALLET_FAIL,
  GET_GASPROJECT_INFO_PUBLIC,
  GET_GASPROJECT_INFO_PUBLIC_SUCCESS,
  GET_GASPROJECT_INFO_PUBLIC_FAIL,
  GET_GASPROJECTS_FULL_FILTER_EXCEL,
  GET_GASPROJECTS_FULL_FILTER_EXCEL_SUCCESS,
  GET_GASPROJECTS_FULL_FILTER_EXCEL_FAIL,
} from "./actionTypes"

// --------------------------------------------------Get GasProject Report
export const getGasProjectReport = values => ({
  type: GET_GASPROJECT_REPORT,
  payload: values,
})

export const getGasProjectReportSuccess = events => ({
  type: GET_GASPROJECT_REPORT_SUCCESS,
  payload: events,
})

export const getGasProjectReportFail = error => ({
  type: GET_GASPROJECT_REPORT_FAIL,
  payload: error,
})
// --------------------------------------------------Get GasProject
export const getGasProjects = values => ({
  type: GET_GASPROJECTS,
  payload: values,
})

export const getGasProjectsSuccess = events => ({
  type: GET_GASPROJECTS_SUCCESS,
  payload: events,
})

export const getGasProjectsFail = error => ({
  type: GET_GASPROJECTS_FAIL,
  payload: error,
})

// --------------------------------------------------Get GasProjects Filter
export const getGasProjectsFilter = values => ({
  type: GET_GASPROJECTS_FILTER,
  payload: values,
})

export const getGasProjectsFilterSuccess = events => ({
  type: GET_GASPROJECTS_FILTER_SUCCESS,
  payload: events,
})

export const getGasProjectsFilterFail = error => ({
  type: GET_GASPROJECTS_FILTER_FAIL,
  payload: error,
})
// --------------------------------------------------Get GasProjects full filter
export const getGasProjectsFullFilter = values => ({
  type: GET_GASPROJECTS_FULL_FILTER,
  payload: values,
})

export const getGasProjectsFullFilterSuccess = events => ({
  type: GET_GASPROJECTS_FULL_FILTER_SUCCESS,
  payload: events,
})

export const getGasProjectsFullFilterFail = error => ({
  type: GET_GASPROJECTS_FULL_FILTER_FAIL,
  payload: error,
})

// --------------------------------------------------Get GasProjects full filter excel
export const getGasProjectsFullFilterExcel = (data) => ({
  type: GET_GASPROJECTS_FULL_FILTER_EXCEL,
  payload: data,
})

export const getGasProjectsFullFilterExcelSuccess = events => ({
  type: GET_GASPROJECTS_FULL_FILTER_EXCEL_SUCCESS,
  payload: events,
})

export const getGasProjectsFullFilterExcelFail = error => ({
  type: GET_GASPROJECTS_FULL_FILTER_EXCEL_FAIL,
  payload: error,
})
// --------------------------------------------------Get GasProject Eng
export const getGasProjectsEng = searchValue => ({
  type: GET_GASPROJECTS_ENG,
  payload: searchValue,
})

export const getGasProjectsEngSuccess = events => ({
  type: GET_GASPROJECTS_ENG_SUCCESS,
  payload: events,
})

export const getGasProjectsEngFail = error => ({
  type: GET_GASPROJECTS_ENG_FAIL,
  payload: error,
})

// --------------------------------------------------Get GasProject Files
export const getGasProjectFiles = gasProjectId => ({
  type: GET_GASPROJECT_FILES,
  payload: gasProjectId,
})

export const getGasProjectsFilesSuccess = events => ({
  type: GET_GASPROJECT_FILES_SUCCESS,
  payload: events,
})

export const getGasProjectsFilesFail = error => ({
  type: GET_GASPROJECT_FILES_FAIL,
  payload: error,
})

// --------------------------------------------------Get GasProject Free
export const getGasProjectFree = fileNumber => ({
  type: GET_GASPROJECT_FREE,
  payload: fileNumber,
})

export const getGasProjectsFreeSuccess = events => ({
  type: GET_GASPROJECT_FREE_SUCCESS,
  payload: events,
})

export const getGasProjectsFreeFail = error => ({
  type: GET_GASPROJECT_FREE_FAIL,
  payload: error,
})
// --------------------------------------------------Get Package Installer
export const getPackageInstaller = (company) => ({
  type: GET_PACKAGEINSTALLER,
  payload: company
})

export const getPackageInstallerSuccess = events => ({
  type: GET_PACKAGEINSTALLER_SUCCESS,
  payload: events,
})

export const getPackageInstallerFail = error => ({
  type: GET_PACKAGEINSTALLER_FAIL,
  payload: error,
})
// --------------------------------------------------Upsert
export const deleteGasProject = id => ({
  type: DELETE_GASPROJECT,
  payload: id,
})
export const deleteGasProjectSuccess = id => ({
  type: DELETE_GASPROJECT_SUCCESS,
  payload: id,
})
export const deleteGasProjectFail = error => ({
  type: DELETE_GASPROJECT_FAIL,
  payload: error,
})

// --------------------------------------------------Delete
export const upsertGasProject = gasProject => ({
  type: UPSERT_GASPROJECT,
  payload: gasProject,
})
export const upsertGasProjectSuccess = gasProject => ({
  type: UPSERT_GASPROJECT_SUCCESS,
  payload: gasProject,
})
export const upsertGasProjectFail = error => ({
  type: UPSERT_GASPROJECT_FAIL,
  payload: error,
})

// --------------------------------------------------Add File
export const addFileGasProject = attachData => ({
  type: ADD_FILE_GASPROJECT,
  payload: attachData,
})
export const addFileGasProjectSingle = attachData => ({
  type: ADD_FILE_GASPROJECT_SINGLE,
  payload: attachData,
})
export const addFileGasProjectSuccess = attachData => ({
  type: ADD_FILE_GASPROJECT_SUCCESS,
  payload: attachData,
})
export const addFileGasProjectFail = error => ({
  type: ADD_FILE_GASPROJECT_FAIL,
  payload: error,
})

// --------------------------------------------------Update gas project process expert stage
export const updateProcessExpertStage = gasProcess => ({
  type: UPDATE_PROCESS_EXPERT_STAGE,
  payload: gasProcess,
})
export const updateProcessMapStage = gasProcess => ({
  type: UPDATE_PROCESS_MAP_STAGE,
  payload: gasProcess,
})
export const updateProcessDefectStage = gasProcess => ({
  type: UPDATE_PROCESS_DEFECT_STAGE,
  payload: gasProcess,
})
export const updateProcessStageSuccess = gasProcess => ({
  type: UPDATE_PROCESS_STAGE_SUCCESS,
  payload: gasProcess,
})
export const updateProcessStageFail = error => ({
  type: UPDATE_PROCESS_STAGE_FAIL,
  payload: error,
})

// --------------------------------------------------Update gas project process expert stage new
export const updateProcessExpertStageNew = gasProcess => ({
  type: UPDATE_PROCESS_EXPERT_STAGE_NEW,
  payload: gasProcess,
})
export const updateProcessMapStageNew = gasProcess => ({
  type: UPDATE_PROCESS_MAP_STAGE_NEW,
  payload: gasProcess,
})
export const updateProcessDefectStageNew = gasProcess => ({
  type: UPDATE_PROCESS_DEFECT_STAGE_NEW,
  payload: gasProcess,
})
export const updateProcessStageNewSuccess = gasProcess => ({
  type: UPDATE_PROCESS_STAGE_NEW_SUCCESS,
  payload: gasProcess,
})
export const updateProcessStageNewFail = error => ({
  type: UPDATE_PROCESS_STAGE_NEW_FAIL,
  payload: error,
})

// --------------------------------------------------Send to Gas
export const sendGasProjectToGas = fileNumber => ({
  type: SEND_GASPROJECT_TOGAS,
  payload: fileNumber,
})
export const sendGasProjectToGasSuccess = fileNumber => ({
  type: SEND_GASPROJECT_TOGAS_SUCCESS,
  payload: fileNumber,
})
export const sendGasProjectToGasFail = error => ({
  type: SEND_GASPROJECT_TOGAS_FAIL,
  payload: error,
})

// --------------------------------------------------Send to Gas
export const submitGasProjectAdmin = gasProjectId => ({
  type: SUBMIT_GASPROJECT_ADMIN,
  payload: gasProjectId,
})
export const submitGasProjectAdminSuccess = model => ({
  type: SUBMIT_GASPROJECT_ADMIN_SUCCESS,
  payload: model,
})
export const submitGasProjectAdminFail = error => ({
  type: SUBMIT_GASPROJECT_ADMIN_FAIL,
  payload: error,
})

// --------------------------------------------------Add package installer
export const addPackageInstaller = gasProject => ({
  type: ADD_PACKAGE_INSTALLER,
  payload: gasProject,
})
export const addPackageInstallerSuccess = events => ({
  type: ADD_PACKAGE_INSTALLER_SUCCESS,
  payload: events,
})
export const addPackageInstallerFail = error => ({
  type: ADD_PACKAGE_INSTALLER_FAIL,
  payload: error,
})


// --------------------------------------------------submit Package installer
export const submitPackage = dataSubmit => ({
  type: SUBMIT_PACKAGE,
  payload: dataSubmit,
})
export const submitPackageSuccess = events => ({
  type: SUBMIT_PACKAGE_SUCCESS,
  payload: events,
})
export const submitPackageFail = error => ({
  type: SUBMIT_PACKAGE_FAIL,
  payload: error,
})

// --------------------------------------------------reset Package installer
export const resetPackage = GpId => ({
  type: RESET_PACKAGE,
  payload: GpId,
})
export const resetPackageSuccess = events => ({
  type: RESET_PACKAGE_SUCCESS,
  payload: events,
})
export const resetPackageFail = error => ({
  type: RESET_PACKAGE_FAIL,
  payload: error,
})

// --------------------------------------------------Resolved Defect
export const resolvedDefect = gpId => ({
  type: RESOLVED_DEFECT,
  payload: gpId,
})
export const resolvedDefectSuccess = events => ({
  type: RESOLVED_DEFECT_SUCCESS,
  payload: events,
})
export const resolvedDefectFail = error => ({
  type: RESOLVED_DEFECT_FAIL,
  payload: error,
})


// --------------------------------------------------Prepare MapStage
export const prepareForMapStage = gpId => ({
  type: PREPARE_MAPSTAGE,
  payload: gpId,
})
export const prepareForMapStageSuccess = events => ({
  type: PREPARE_MAPSTAGE_SUCCESS,
  payload: events,
})
export const prepareForMapStageFail = error => ({
  type: PREPARE_MAPSTAGE_FAIL,
  payload: error,
})

// --------------------------------------------------Prepare Expert Stage
export const prepareForFirstSupervisionStage = gpId => ({
  type: PREPARE_FIRSTSUPERVISION_STAGE,
  payload: gpId,
})
export const prepareForFirstSupervisionStageSuccess = events => ({
  type: PREPARE_FIRSTSUPERVISION_STAGE_SUCCESS,
  payload: events,
})
export const prepareForFirstSupervisionStageFail = error => ({
  type: PREPARE_FIRSTSUPERVISION_STAGE_FAIL,
  payload: error,
})

// --------------------------------------------------Prepare Expert Stage
export const prepareForDesignStage = gpId => ({
  type: PREPARE_DESIGNS_STAGE,
  payload: gpId,
})
export const prepareForDesignStageSuccess = events => ({
  type: PREPARE_DESIGNS_STAGE_SUCCESS,
  payload: events,
})
export const prepareForDesignStageFail = error => ({
  type: PREPARE_DESIGNS_STAGE_FAIL,
  payload: error,
})


// --------------------------------------------------Update gasProject Details
export const updateGasProjectDetails = gasProjectDetail => ({
  type: UPDATE_GASPROJECT_DETAILS,
  payload: gasProjectDetail,
})
export const updateGasProjectDetailsSuccess = gasProjectDetail => ({
  type: UPDATE_GASPROJECT_DETAILS_SUCCESS,
  payload: gasProjectDetail,
})
export const updateGasProjectDetailsFail = error => ({
  type: UPDATE_GASPROJECT_DETAILS_FAIL,
  payload: error,
})

// --------------------------------------------------Update gasProject Details New
export const updateGasProjectDetailsNew = gasProjectDetail => ({
  type: UPDATE_GASPROJECT_DETAILS_NEW,
  payload: gasProjectDetail,
})
export const updateGasProjectDetailsNewSuccess = gasProjectDetail => ({
  type: UPDATE_GASPROJECT_DETAILS_NEW_SUCCESS,
  payload: gasProjectDetail,
})
export const updateGasProjectDetailsNewFail = error => ({
  type: UPDATE_GASPROJECT_DETAILS_NEW_FAIL,
  payload: error,
})

// --------------------------------------------------Update gasProject
export const updateGasProject = gasProject => ({
  type: UPDATE_GASPROJECT,
  payload: gasProject,
})
export const updateGasProjectSuccess = gasProject => ({
  type: UPDATE_GASPROJECT_SUCCESS,
  payload: gasProject,
})
export const updateGasProjectFail = error => ({
  type: UPDATE_GASPROJECT_FAIL,
  payload: error,
})
// --------------------------------------------------Update gasProject by Eng
export const updateGasProjectEng = gasProject => ({
  type: UPDATE_GASPROJECT_ENG,
  payload: gasProject,
})
// --------------------------------------------------Update gasProject by Eng
export const updateGasProjectEngNew = gasProject => ({
  type: UPDATE_GASPROJECT_ENG_NEW,
  payload: gasProject,
})

// --------------------------------------------------Cancel GasProject
export const stopGasProject = data => ({
  type: STOP_GASPROJECT,
  payload: data,
})
export const stopGasProjectSuccess = data => ({
  type: STOP_GASPROJECT_SUCCESS,
  payload: data,
})
export const stopGasProjectFail = error => ({
  type: STOP_GASPROJECT_FAIL,
  payload: error,
})


// --------------------------------------------------Update gas project process submitDesignStage new

export const submitDesignStage = gasProcess => ({
  type: SUBMIT_DESIGN_STAGE,
  payload: gasProcess,
})

export const submitDesignStageSuccess = gasProcess => ({
  type: SUBMIT_DESIGN_STAGE_SUCCESS,
  payload: gasProcess,
})
export const submitDesignStageFail = error => ({
  type: SUBMIT_DESIGN_STAGE_FAIL,
  payload: error,
})

// --------------------------------------------------Update gas project process submitDesignStage new

export const submitFirstSupervisionStage = gasProcess => ({
  type: SUBMIT_FIRSTSUPERVISION_STAGE,
  payload: gasProcess,
})

export const submitFirstSupervisionStageSuccess = gasProcess => ({
  type: SUBMIT_FIRSTSUPERVISION_STAGE_SUCCESS,
  payload: gasProcess,
})
export const submitFirstSupervisionStageFail = error => ({
  type: SUBMIT_FIRSTSUPERVISION_STAGE_FAIL,
  payload: error,
})



// --------------------------------------------------Update gasProject CheckList
export const updateGasProjectCheckList = model => ({
  type: UPDATE_GASPROJECT_CHECKLIST,
  payload: model,
})
export const updateGasProjectCheckListSuccess = model => ({
  type: UPDATE_GASPROJECT_CHECKLIST_SUCCESS,
  payload: model,
})
export const updateGasProjectCheckListFail = error => ({
  type: UPDATE_GASPROJECT_CHECKLIST_FAIL,
  payload: error,
})



// --------------------------------------------------DELETE GasProject File
export const deleteGasProjectFile = id => ({
  type: DELETE_GASPROJECT_FILE,
  payload: id,
})
export const deleteGasProjectFileSuccess = id => ({
  type: DELETE_GASPROJECT_FILE_SUCCESS,
  payload: id,
})
export const deleteGasProjectFileFail = error => ({
  type: DELETE_GASPROJECT_FILE_FAIL,
  payload: error,
})


// --------------------------------------------------Pay By Wallet Exe
export const payByExecutorWallet = gpId => ({
  type: PAY_BY_EXECUTOR_WALLET,
  payload: gpId,
})
export const payByExecutorWalletSuccess = events => ({
  type: PAY_BY_EXECUTOR_WALLET_SUCCESS,
  payload: events,
})
export const payByExecutorWalletFail = error => ({
  type: PAY_BY_EXECUTOR_WALLET_FAIL,
  payload: error,
})


// --------------------------------------------------Get getGasProjectInfoPublic
export const getGasProjectInfoPublic = gasProjectId => ({
  type: GET_GASPROJECT_INFO_PUBLIC,
  payload: gasProjectId,
})

export const getGasProjectInfoPublicSuccess = events => ({
  type: GET_GASPROJECT_INFO_PUBLIC_SUCCESS,
  payload: events,
})

export const getGasProjectInfoPublicFail = error => ({
  type: GET_GASPROJECT_INFO_PUBLIC_FAIL,
  payload: error,
})


//-----------------------------------------------------Reset
export const resetGasProjectFlag = () => {
  return {
    type: RESET_GASPROJECT_FLAG,
  }
}
